import * as React from 'react'
import { useCallback } from 'react'
import { BulkReassignForm } from '@user/components/xGrid'
import { BulkReassignInput } from '@user/components/xGrid/atoms/BulkActions/typings/BulkReassign'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { ENTITY_TYPES } from '@sales-center/common'
import { bulkReassignOpps } from '@user/store/opportunity'

export const BulkReassignOpps: React.FC = () => {
  const dispatch = useAppDispatch()

  const validateRows = useCallback(
    async (model: BulkReassignInput) => {
      const result = await dispatch(bulkReassignOpps({ model }))
      if (bulkReassignOpps.fulfilled.match(result)) return result.payload.model
    },
    [dispatch],
  )

  const onSubmit = useCallback(
    async (model: BulkReassignInput) =>
      void (await dispatch(bulkReassignOpps({ mode: 'commit', model }))),
    [dispatch],
  )

  return (
    <BulkReassignForm
      entityType={ENTITY_TYPES.Opportunity}
      validateRows={validateRows}
      onSubmit={onSubmit}
    />
  )
}
BulkReassignOpps.displayName = 'BulkReassignOpps'
